import React, { useState, useEffect, useMemo } from 'react';

type Props = {
  durationInSeconds: number;
  onDurationEnd?: () => void;
};

const CIRCLE_RADIUS = 8;
const CIRCLE_STROKE_WIDTH = 2;
const CIRCUMFERENCE = 2 * Math.PI * CIRCLE_RADIUS;

function SnackbarTimer({ durationInSeconds, onDurationEnd }: Props) {
  const [progressInSeconds, setProgress] = useState(0);

  const updateConfig = useMemo(() => {
    const updateSpeed =
      durationInSeconds < 30 ? 50 : durationInSeconds < 60 ? 100 : 1000;
    const updateAmount = updateSpeed / 1000;
    return {
      updateSpeed,
      updateAmount,
    };
  }, [durationInSeconds]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (progressInSeconds < durationInSeconds) {
        setProgress((prevProgress) => prevProgress + updateConfig.updateAmount);
      } else {
        onDurationEnd?.();
      }
    }, updateConfig.updateSpeed);

    return () => clearInterval(interval);
  }, [progressInSeconds]);

  const oneSecondProgress = CIRCUMFERENCE / durationInSeconds;
  const strokeDashoffset =
    CIRCUMFERENCE - oneSecondProgress * progressInSeconds;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="snackbar__progress"
    >
      <circle
        cx="12"
        cy="12"
        r={CIRCLE_RADIUS}
        stroke="gray"
        strokeWidth={CIRCLE_STROKE_WIDTH}
        fill="none"
      />
      <circle
        cx="12"
        cy="12"
        r={CIRCLE_RADIUS}
        stroke="white"
        strokeWidth={CIRCLE_STROKE_WIDTH}
        fill="none"
        strokeDasharray={CIRCUMFERENCE}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default SnackbarTimer;
